import type { Feature } from './feature'

export class Selectors {
  /** Current in-flight visual navigation transition. */
  public readonly transition
  /** Indicates whether app content should cover itself with a loader. */
  public readonly isTransitioning

  constructor(feature: Feature) {
    this.transition = feature.state.project(state => state.transition)
    this.isTransitioning = this.transition.project(
      transition => transition !== undefined,
    )
  }
}
